import { GoogleTagManager as GoogleTagManagerComponent } from '@next/third-parties/google';
import Script from 'next/script';

type GoogleTagManagerProps = {
  gtmId?: string;
};

export const GoogleTagManager = ({ gtmId }: GoogleTagManagerProps) => {
  if (!gtmId) return null;

  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=dVPpjtySirx7G4CMi2bBsg&gtm_preview=env-126&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;

  return (
    <>
      <GoogleTagManagerComponent gtmId={gtmId} />
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: gtmScript }}
      />
    </>
  );
};
